import React from "react";
import { Count } from "./Styled";

type ItemProps = {
  title: string;
};

const Item: React.FunctionComponent<ItemProps> = ({ title }) => {
  return (
     <><span>{title}</span><Count></Count></>
  );
};

export default Item;
